import React from 'react';

const DisplaySwitcher = (props) => {
    return (
        <div className="display-changer">


            {props.mapMode ? (
                <button className={(props.currentDisplayMode === 'map') ? 'btn btn--icon btn--icon--active' : 'btn btn--icon'}
                        onClick={()=> props.setDisplayMode('map')}>
                    <i className="fas fa-map-marker-alt"></i>
                </button>
            ) : '' }
            <button className={(props.currentDisplayMode === 'list') ? 'btn btn--icon btn--icon--active' : 'btn btn--icon'}
                    onClick={()=> props.setDisplayMode('list')}>
                <i className="fas fa-list"></i>
            </button>

            <button className={(props.currentDisplayMode === 'card') ? 'btn btn--icon btn--icon--active' : 'btn btn--icon'}
                    onClick={()=> props.setDisplayMode('card')} >
                <i className="fas fa-th"></i>
            </button>
        </div>
    );
};

export default DisplaySwitcher;
